<script setup>
import BaseCell from '@js/components/tables/cells/BaseCell.vue';
import { formatPercentage, formatPrice } from '@js/utils/formatter';

const {
    price,
    align = 'left',
    suffix,
    withDecimals = true,
    currency = '€',
    percentage,
    percentageColor,
} = defineProps({
    price: {
        type: [Number],
        required: true,
    },
    align: {
        type: String,
        required: false,
    },
    suffix: {
        type: String,
        required: false,
    },
    withDecimals: {
        type: Boolean,
        required: false,
    },
    currency: {
        type: String,
        required: false,
    },
    button: {
        type: Object,
        required: false,
    },
    percentage: {
        type: Boolean,
        required: false,
    },
    percentageColor: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <BaseCell :align="align" class="whitespace-nowrap">
        <div class="text-lg font-bold">
            <div v-if="$slots.actions">
                {{ formatPrice(price, withDecimals, 1, currency) }}
                <template v-if="suffix">{{ suffix }}</template>
            </div>

            <template v-else>
                {{ formatPrice(price, withDecimals, 1, currency) }}
                <template v-if="suffix">{{ suffix }}</template>
            </template>
        </div>

        <div
            v-if="percentage"
            class="inline-flex items-center gap-1 rounded text-sm font-bold"
            :class="{
                'bg-green-200 px-2 text-green-600': percentageColor === 'green',
                'bg-red-200 px-2 text-red-600': percentageColor === 'red',
                'bg-gray-200 px-2 text-gray-600': !percentageColor,
            }"
        >
            -{{ formatPercentage(percentage) }}
        </div>

        <div v-if="$slots.actions" class="flex gap-2">
            <slot name="actions" />
        </div>
    </BaseCell>
</template>
